export default __webpack_public_path__ + "static/media/StageTimer.e73dd291.mp3";